// extracted by mini-css-extract-plugin
export var disabledText = "disabled-text_ZpfZn9AJwrbginRpKKhr";